module.exports = __webpack_public_path__ + "img/image32.fa724b2a.png";